<template>
	<label class="app-checkbox" :class="{ 'app-checkbox-invalid': error?.length }">
		<input v-model="model" :value="value" type="checkbox" />
		<slot name="label">{{ label }}</slot>
	</label>
</template>

<script setup lang="ts">
	interface IProp {
		value?: never;
		label?: string;
		error?: string;
		disabled?: boolean;
	}

	defineProps<IProp>();

	const model = defineModel<Array<never> | boolean>({ required: true, default: false });
</script>

<style scoped lang="scss">
	.app-checkbox {
		display: flex;
		flex-wrap: nowrap;
		align-items: start;
		cursor: pointer;
		gap: 11px;

		--checkbox-size: 20px;

		input {
			-webkit-appearance: none;
			appearance: none;
			background-color: var(--color-white);
			margin: 0;
			min-width: var(--checkbox-size, 22px);
			max-width: var(--checkbox-size, 22px);
			max-height: var(--checkbox-size, 22px);
			min-height: var(--checkbox-size, 22px);
			border-radius: 4px;
			position: relative;
			border: 1px solid var(--color-grey-dark);

			transition: color ease-in-out 0.2s, background-color ease-in-out 0.2s,
				border-color ease-in-out 0.2s;

			&::before {
				content: '';
				position: absolute;
				left: 0;
				right: 0;
				top: 0;
				bottom: 0;
				margin: auto;
				width: calc(var(--checkbox-size, 22px) * 0.7);
				height: calc(var(--checkbox-size, 22px) * 0.45);
				transform: scale(0);
				background-image: url('/images/svg/checked.svg');
				background-position: center;
				background-repeat: no-repeat;
				background-size: contain;
				transition: all 0.1s;
			}

			&:hover {
				border-color: var(--color-black);
				background-color: var(--color-grey);
			}

			&:checked {
				border-color: var(--color-black);
			}

			&:checked::before {
				transform: scale(1);
			}
		}
	}

	.app-checkbox-invalid {
		color: var(--color-error);

		input,
		input:hover {
			border: 1px solid var(--color-error);
		}

		input:checked {
			border-color: var(--color-error);
		}
	}
</style>
